module.exports = __webpack_public_path__ + "img/txtImg.fe8316a2.png";